export default __webpack_public_path__ + "static/media/playResponsibly.59c45757.svg";